import axios from 'axios'

// 后台服务器接口根结点
let urlBase = process.env.URL_BASE

// let token = window.localStorage.getItem('loginToken')
// if (token === '' || token === null) {
//   token = ''
// }
// 通用配置
const instance = axios.create({
  // 服务器根结点
  baseURL: urlBase,
  withCredentials: true,
  timeout: 0
})

// 拦截返回内容
instance.interceptors.response.use((response) => {
  switch (response.data.code) {
    // 如果code值为300
    case 300:
      response.data.msg = window.vm.$t('errCode.code.301') /* not login */
      return Promise.reject(response.data)
    // 如果code值为400
    case 400:
      response.data.msg = window.vm.$t('errCode.code.400') /* param error */
      return Promise.reject(response.data)
    // 如果code值为404
    case 404:
      response.data.msg = window.vm.$t('errCode.code.404') /* 接口地址错误 */
      return Promise.reject(response.data)
    // 如果code值为500
    case 500:
      response.data.msg = window.vm.$t('errCode.code.500') /* server error */
      return Promise.reject(response.data)
    default:
  }
  // 错误码为200 继续
  return response
}, (err) => {
  // 如果连接失败
  // if (err instanceof Error && err.message === 'Network Error') {
  //   // 返回错误内容
  //   let errMsg = '服务器连接失败'
  //   return Promise.reject(errMsg)
  // } else {
  // 返回错误内容
  return Promise.reject(err)
  // }
})

export default instance



// WEBPACK FOOTER //
// ./src/plugin/axios.js